export const GET_VENDORS = "GET_VENDORS"
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS"
export const GET_VENDORS_FOR_USER = "GET_VENDORS_FOR_USER"
export const GET_VENDORS_FOR_USER_SUCCESS = "GET_VENDORS_FOR_USER_SUCCESS"
export const GET_VENDORS_FOR_USER_FAILED = "GET_VENDORS_FOR_USER_FAILED"

export const UPDATE_CLIENT_CONFIGS = "UPDATE_CLIENT_CONFIGS"
export const UPDATE_CLIENT_CONFIGS_SUCCESS = "UPDATE_CLIENT_CONFIGS_SUCCESS"
export const UPDATE_CLIENT_CONFIGS_FAIL = "UPDATE_CLIENT_CONFIGS_FAIL"

export const API_ERROR = "API_ERROR"

export const GET_CLIENTS_TABLE_DATA = "GET_CLIENTS_TABLE_DATA"
export const GET_CLIENTS_TABLE_DATA_SUCCESS = "GET_CLIENTS_TABLE_DATA_SUCCESS"
export const GET_CLIENTS_TABLE_DATA_FAILED = "GET_CLIENTS_TABLE_DATA_FAILED"

export const ADD_CLIENT = "ADD_CLIENT"
export const ADD_CLIENT_SUCCESS = "ADD_CLIENT_SUCCESS"
export const ADD_CLIENT_FAILED = "ADD_CLIENT_FAILED"

export const POST_CLIENT_SUCCESS_MANAGER = "POST_CLIENT_SUCCESS_MANAGER"
export const POST_CLIENT_SUCCESS_MANAGER_SUCCESS =
  "POST_CLIENT_SUCCESS_MANAGER_SUCCESS"
export const POST_CLIENT_SUCCESS_MANAGER_FAILED =
  "POST_CLIENT_SUCCESS_MANAGER_FAILED"

export const DELETE_CLIENT = "DELETE_CLIENT"
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS"
export const DELETE_CLIENT_FAILED = "DELETE_CLIENT_FAILED"

export const OPEN_DELETE_CLIENT_MODAL = "OPEN_DELETE_CLIENT_MODAL"
export const HIDE_DELETE_CLIENT_MODAL = "HIDE_DELETE_CLIENT_MODAL"

export const GET_CLIENT = "GET_CLIENT"
export const GET_CLIENT_SUCCESS = "GET_CLIENT_SUCCESS"
export const GET_CLIENT_FAILED = "GET_CLIENT_FAILED"

export const GET_CLIENT_SUCCESS_MANAGER = "GET_CLIENT_SUCCESS_MANAGER"
export const GET_CLIENT_SUCCESS_MANAGER_SUCCESS =
  "GET_CLIENT_SUCCESS_MANAGER_SUCCESS"
export const GET_CLIENT_SUCCESS_MANAGER_FAILED =
  "GET_CLIENT_SUCCESS_MANAGER_FAILED"

export const RESET_CLIENT_FORM = "RESET_CLIENT_FORM"

export const UPDATE_CLIENT = "UPDATE_CLIENT"
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS"
export const UPDATE_CLIENT_FAILED = "UPDATE_CLIENT_FAILED"

export const UPDATE_CLIENT_SUCCESS_MANAGER = "UPDATE_CLIENT_SUCCESS_MANAGER"
export const UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS =
  "UPDATE_CLIENT_SUCCESS_MANAGER_SUCCESS"
export const UPDATE_CLIENT_SUCCESS_MANAGER_FAILED =
  "UPDATE_CLIENT_SUCCESS_MANAGER_FAILED"

export const GET_VENDOR_CONFIG = "GET_VENDOR_CONFIG"
export const GET_VENDOR_CONFIG_SUCCESS = "GET_VENDOR_CONFIG_SUCCESS"
export const GET_VENDOR_CONFIG_FAILED = "GET_VENDOR_CONFIG_FAILED"

export const GET_VENDOR_EMAIL_CONFIG = "GET_VENDOR_EMAIL_CONFIG"
export const GET_VENDOR_EMAIL_CONFIG_SUCCESS = "GET_VENDOR_EMAIL_CONFIG_SUCCESS"
export const GET_VENDOR_EMAIL_CONFIG_FAILED = "GET_VENDOR_EMAIL_CONFIG_FAILED"

export const GET_EXPERIENCES_FEATURES = "GET_EXPERIENCES_FEATURES"
export const GET_EXPERIENCES_FEATURES_SUCCESS =
  "GET_EXPERIENCES_FEATURES_SUCCESS"
export const GET_EXPERIENCES_FEATURES_FAILED = "GET_EXPERIENCES_FEATURES_FAILED"

export const GET_LANDING_SCREEN_FEATURES = "GET_LANDING_SCREEN_FEATURES"
export const GET_LANDING_SCREEN_FEATURES_SUCCESS =
  "GET_LANDING_SCREEN_FEATURES_SUCCESS"
export const GET_LANDING_SCREEN_FEATURES_FAILED =
  "GET_LANDING_SCREEN_FEATURES_FAILED"

export const UPDATE_CLIENT_FEATURES = "UPDATE_CLIENT_FEATURES"
export const UPDATE_CLIENT_FEATURES_SUCCESS = "UPDATE_CLIENT_FEATURES_SUCCESS"
export const UPDATE_CLIENT_FEATURES_FAILED = "UPDATE_CLIENT_FEATURES_FAILED"

export const UPDATE_CLIENT_SETTINGS = "UPDATE_CLIENT_SETTINGS"
export const UPDATE_CLIENT_SETTINGS_SUCCESS = "UPDATE_CLIENT_SETTINGS_SUCCESS"
export const UPDATE_CLIENT_SETTINGS_FAILED = "UPDATE_CLIENT_SETTINGS_FAILED"

export const RESET_CLIENT_SETTINGS_FORM = "RESET_CLIENT_SETTINGS_FORM"

export const UPDATE_CLIENT_EMAIL_CONFIG = "UPDATE_CLIENT_EMAIL_CONFIG"
export const UPDATE_CLIENT_EMAIL_CONFIG_SUCCESS =
  "UPDATE_CLIENT_EMAIL_CONFIG_SUCCESS"
export const UPDATE_CLIENT_EMAIL_CONFIG_FAILED =
  "UPDATE_CLIENT_EMAIL_CONFIG_FAILED"

export const GET_VENDOR_PAYMENT_CONFIG = "GET_VENDOR_PAYMENT_CONFIG"
export const GET_VENDOR_PAYMENT_CONFIG_SUCCESS =
  "GET_VENDOR_PAYMENT_CONFIG_SUCCESS"
export const GET_VENDOR_PAYMENT_CONFIG_FAILED =
  "GET_VENDOR_PAYMENT_CONFIG_FAILED"

export const UPDATE_VENDOR_PAYMENT_CONFIG = "UPDATE_VENDOR_PAYMENT_CONFIG"
export const UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS =
  "UPDATE_VENDOR_PAYMENT_CONFIG_SUCCESS"
export const UPDATE_VENDOR_PAYMENT_CONFIG_FAILED =
  "UPDATE_VENDOR_PAYMENT_CONFIG_FAILED"
